import { writable } from 'svelte/store';
export const wait = async (ms) => new Promise(res => setTimeout(() => res(), ms));
export const clamp = (value, min, max) => {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
};
/**
 * Persist a writable Svelte store to local storage
 */
export const persistent = (key, initialValue) => {
    let value = initialValue;
    try {
        const json = localStorage.getItem(key);
        if (json) {
            value = JSON.parse(json);
        }
    }
    catch (err) {
        console.error(err);
    }
    const state = writable(value);
    state.subscribe(($value) => {
        localStorage.setItem(key, JSON.stringify($value));
    });
    return state;
};
export const setCSSVar = ([name, value]) => document.documentElement.style.setProperty(`--${name}`, value);
export const getCSSVar = (name) => getComputedStyle(document.body).getPropertyValue(`--${name}`);
export const getCSSVarPx = (name) => parseInt(getCSSVar(name).split('px')[0]);
// TODO Terrible name
export const waitForEvent = (Constructor, props, successEvent, errorEvent) => {
    return new Promise((resolve, reject) => {
        const element = new Constructor({
            target: document.body,
            props,
        });
        element.$on(successEvent, ({ detail }) => {
            resolve(Object.assign({}, detail));
            element.$destroy();
        });
        element.$on(errorEvent, ({ detail }) => {
            console.log('ERROR EVENT', detail);
            reject(Object.assign({}, detail));
            element.$destroy();
        });
    });
};
export async function loadImageFromUrl(url, opts = { anonymous: true }) {
    const image = new Image();
    if (opts.anonymous) {
        image.crossOrigin = 'anonymous';
    }
    image.src = url;
    return new Promise((resolve, reject) => {
        image.onload = () => resolve(image);
        image.onerror = (e) => reject(`Filter: Could not load ${url}`);
    });
}
export const copyImageData = ({ ctx, x, y, image }) => {
    ctx.drawImage(image, x, y, image.width, image.height);
    return ctx.getImageData(x, y, image.width, image.height);
};
export const renderImageData = ({ imageData, ctx, x, y }) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.putImageData(imageData, x, y);
};
